<div class="board main-board">
    <p>faults works!</p>
</div>